import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "checkbox is-outlined is-info" }
const _hoisted_2 = ["checked"]
const _hoisted_3 = { class: "field" }
const _hoisted_4 = { class: "control" }
const _hoisted_5 = { class: "select" }
const _hoisted_6 = ["selected"]
const _hoisted_7 = ["value", "selected"]
const _hoisted_8 = { class: "field" }
const _hoisted_9 = { class: "control" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "field" }
const _hoisted_12 = { class: "control" }
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "field" }
const _hoisted_15 = { class: "control" }
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "field" }
const _hoisted_18 = { class: "control" }
const _hoisted_19 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", null, [
    (_ctx.showAdjustColumn)
      ? (_openBlock(), _createElementBlock("td", {
          key: 0,
          class: _normalizeClass({'has-background-primary': _ctx.values['ratio'] > 0, 'has-background-danger': _ctx.values['ratio'] <= 0}),
          style: {"text-align":"center","vertical-align":"middle","padding":"8px"}
        }, [
          _createElementVNode("label", _hoisted_1, [
            _createElementVNode("input", {
              type: "checkbox",
              name: "select_for_adjustment",
              checked: _ctx.values['select_for_adjustment'],
              onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.updateRow && _ctx.updateRow(...args)))
            }, null, 40, _hoisted_2),
            _cache[6] || (_cache[6] = _createElementVNode("span", null, null, -1))
          ])
        ], 2))
      : _createCommentVNode("", true),
    _createElementVNode("td", {
      class: _normalizeClass({'has-background-primary': _ctx.values['ratio'] > 0, 'has-background-danger': _ctx.values['ratio'] <= 0})
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("select", {
              name: "product",
              onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateRow && _ctx.updateRow(...args)))
            }, [
              _createElementVNode("option", {
                value: "0",
                selected: _ctx.values['product'] === '0'
              }, "---", 8, _hoisted_6),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredProducts, (product) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: `product-${product.id}`,
                  value: product.id,
                  selected: _ctx.values['product'] === product.id
                }, _toDisplayString(product.name), 9, _hoisted_7))
              }), 128))
            ], 32)
          ])
        ])
      ])
    ], 2),
    _createElementVNode("td", {
      class: _normalizeClass({'has-background-primary': _ctx.values['ratio'] > 0, 'has-background-danger': _ctx.values['ratio'] <= 0})
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("input", {
            class: "input",
            type: "number",
            name: "price",
            value: _ctx.values['price'],
            onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateRow && _ctx.updateRow(...args))),
            onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.initValue && _ctx.initValue(...args)))
          }, null, 40, _hoisted_10)
        ])
      ])
    ], 2),
    _createElementVNode("td", {
      class: _normalizeClass({'has-background-primary': _ctx.values['ratio'] > 0, 'has-background-danger': _ctx.values['ratio'] <= 0})
    }, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("input", {
            class: "input",
            type: "number",
            name: "ratio",
            value: _ctx.values['ratio'],
            onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.updateRow && _ctx.updateRow(...args))),
            onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.initValue && _ctx.initValue(...args)))
          }, null, 40, _hoisted_13)
        ])
      ])
    ], 2),
    ('leg' in _ctx.result)
      ? (_openBlock(), _createElementBlock("td", {
          key: 1,
          class: _normalizeClass({'has-background-primary': _ctx.values['ratio'] > 0, 'has-background-danger': _ctx.values['ratio'] <= 0})
        }, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("input", {
                class: "input",
                disabled: "disabled",
                value: _ctx.result.leg
              }, null, 8, _hoisted_16)
            ])
          ])
        ], 2))
      : _createCommentVNode("", true),
    ('weighted' in _ctx.result)
      ? (_openBlock(), _createElementBlock("td", {
          key: 2,
          class: _normalizeClass({'has-background-primary': _ctx.values['ratio'] > 0, 'has-background-danger': _ctx.values['ratio'] <= 0})
        }, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("input", {
                class: "input",
                disabled: "disabled",
                value: _ctx.result.weighted
              }, null, 8, _hoisted_19)
            ])
          ])
        ], 2))
      : _createCommentVNode("", true)
  ]))
}